import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { RegionDistrictEntity } from '../../domain/entities/RegionDistrictEntity'
import type { DistrictsByRegionDistrictAdminDto } from '@/backend/market'

export class RegionDistrictModel extends RegionDistrictEntity {
  constructor(dataDto: DistrictsByRegionDistrictAdminDto) {
    super()
    mapEntityProperties<RegionDistrictModel>(this, dataDto, {
      exclude: ['boundary'],
      map: {
        boundaryData: dataDto.boundary?.map((boundary) => {
          return {
            longitude: boundary.longitude,
            latitude: boundary.latitude
          }
        })
      }
    })
  }
}
